import React from 'react'
import { observer } from 'mobx-react-lite'

import { Box, LinearProgress, makeStyles, Typography } from '@material-ui/core'

import { UnprocessedValueError } from '../common/tsUtils'

import { ManualUserSyncStep } from '../server/mpsklad_core/Entity/Enums/ManualUserSyncStep'
import { ManualUserSyncJobModel } from '../server/mpsklad_core/Models/ManualUserSyncJobModel'
import { ManualUserSyncJobState } from '../server/mpsklad_core/Entity/Enums/ManualUserSyncJobState'

export type SyncProgressBarProps = {
  syncJob: ManualUserSyncJobModel
}

export const SyncProgressBar =
  observer(
    ({syncJob}: SyncProgressBarProps) => {
      const classes = useStyles()

      return (
        <Box mt={2} width="100%">
          <LinearProgress className={classes.progressBar}/>

          <Typography variant="body2" color="textSecondary" style={{marginTop: 8}}>
            Статус: {formatJobState(syncJob)}
          </Typography>
        </Box>
      )
    })

export const formatJobState =
  (syncJob: ManualUserSyncJobModel): string => {
    switch (syncJob.state) {
      case ManualUserSyncJobState.Enqueued:
        return 'в очереди...'

      case ManualUserSyncJobState.Processing: {
        switch (syncJob.currentStep) {
          case null:
          case undefined:
            return 'синхронизация выполняется...'

          case ManualUserSyncStep.PullingProducts:
            return 'получение товаров...'

          case ManualUserSyncStep.PullingStocks:
            return 'получение остатков...'

          case ManualUserSyncStep.PushingStocks:
            return 'отправка остатков в МойСклад...'

          default:
            throw new UnprocessedValueError('ManualUserSyncStep', syncJob.currentStep)
        }
      }

      case ManualUserSyncJobState.Succeeded:
        return 'завершено успешно'

      case ManualUserSyncJobState.Failed:
        return 'завершено с ошибкой'

      case ManualUserSyncJobState.Skipped:
        return 'пропущено - идёт автоматическая синхронизация'

      default:
        throw new UnprocessedValueError('ManualUserSyncJobState', syncJob.state)
    }
  }

const useStyles = makeStyles({
  progressBar: {
    backgroundColor: '#e3f2fd', // Light blue background
    '& .MuiLinearProgress-bar': {
      backgroundColor: '#2196f3' // Blue progress bar
    }
  }
})